import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import DialogActions from '@zenbusiness/zui/DialogActions';
import Divider from '@zenbusiness/zui/Divider';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const RestartHeaderStack = superstyled({
  tag: Stack,
  name: 'ConfirmRestartSubscription',
  slot: 'RestartHeaderStack',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(3),
  }),
});

export const SummaryCard = superstyled({
  tag: Box,
  name: 'ConfirmRestartSubscription',
  slot: 'SummaryCard',
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '1.25rem',
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(3),
  }),
});

export const ServiceNameText = superstyled({
  tag: Text,
  name: 'ConfirmRestartSubscription',
  slot: 'ServiceNameText',
  styles: {
    textTransform: 'capitalize',
  },
});

export const SummaryDivider = superstyled({
  tag: Divider,
  name: 'ConfirmRestartSubscription',
  slot: 'SummaryDivider',
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
  }),
});

export const PaymentMethodStack = superstyled({
  tag: Stack,
  name: 'ConfirmRestartSubscription',
  slot: 'PaymentMethodStack',
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2.5),
  }),
});

export const ChangePaymentButton = superstyled({
  tag: Button,
  name: 'ConfirmRestartSubscription',
  slot: 'ChangePaymentButton',
  styles: {
    minWidth: 0,
    padding: 0,
  },
});

export const ConsentFormControlLabel = superstyled({
  tag: FormControlLabel,
  name: 'ConfirmRestartSubscription',
  slot: 'ConsentFormControlLabel',
  styles: {
    marginLeft: 0,
  },
});

export const RestartDialogActions = superstyled({
  tag: DialogActions,
  name: 'ConfirmRestartSubscription',
  slot: 'RestartDialogActions',
  styles: ({ theme }) => ({
    paddingInline: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }),
});

export const SubmitButton = superstyled({
  tag: Button,
  name: 'ConfirmRestartSubscription',
  slot: 'SubmitButton',
  styles: {
    minWidth: 180,
  },
});
